<template>
  <div>
    <base-header class="header pb-6 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-md-10">
            <p class="text-white mt-3 mb-1">
              A Stars está estrategicamente posicionada para destacar Startups
              no cenário nacional e internacional. Contamos com uma rede de mais
              de 100 mentores de altíssima qualidade. Inovamos ao conectar
              Startups com mentores de negócios que possuem destacada expertise
              no mercado tradicional, além de mentores especialistas e de visão
              global em tecnologia e inovação.
            </p>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt-1"></div>
  </div>
</template>
<script>
export default {
  name: "dashboard-admin",
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>
<style></style>
